import { useGraphQLQuery } from '@betterment/js-runtime';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { EnvelopeAccountProjectionsDocument } from '../../graphql/envelopeAccountProjections.generated';

export const useEnvelopeAccountProjections = () => {
  const accountId = useRequiredParam('accountId');

  const { data } = useGraphQLQuery(EnvelopeAccountProjectionsDocument, {
    variables: { id: accountId },
    throwOnError: true,
  });

  return { data };
};
